/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ShopSearchBrandsRequest} from '@cash-web/protos/squareup/cash/customersearch/api/ShopSearchBrands.pb'
import {ShopSearchBrandsResponse} from '@cash-web/protos/squareup/cash/customersearch/api/ShopSearchBrands.pb'


export const shopSearchBrands = (request: ShopSearchBrandsRequest, options?: CashRequestOptions) => post<ShopSearchBrandsRequest, ShopSearchBrandsResponse>("/2.0/cash/shop-search-brands", request, {...options, rejectOnError: true })